// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".signInPage-root-un1 {\n}\n\n@media (min-width: 961px) {\n    .signInPage-contentContainer-SyI {\n        padding-bottom: 2rem;\n        border: 2px solid rgb(var(--venia-global-color-border));\n        border-radius: 0.375rem;\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "signInPage-root-un1 pb-20",
	"contentContainer": "signInPage-contentContainer-SyI"
};
export default ___CSS_LOADER_EXPORT___;
